import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components"
import Slider from "react-slick";
import { media } from "utils/Media"
import WPLink from "components/shared/WPLink"

const SlideWrap = styled.div`
  width: 320px;
  margin: 0 auto;
  
  @media ${media.md} {
    width: 768px;
  }
  @media ${media.lg} {
    width: 970px;
  }
`

const FooterBellyband = ({data}) => {

  var settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    focusable: false,  
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  
  return(
    <SlideWrap className="pb-4">
      <Slider {...settings}>
        {data?.map((ad, i) => {
          return(
            <div key={`footerBellyband${i}`}>
              <WPLink url={ad.link.url} target={ad.link.target}>
                <GatsbyImage
                  image={ad.desktopImage.localFile.childImageSharp.gatsbyImageData}
                  alt={ad.desktopImage.altText}
                  className="d-none d-lg-block"
                />
                <GatsbyImage
                  image={ad.tabletImage.localFile.childImageSharp.gatsbyImageData}
                  alt={ad.tabletImage.altText}
                  className="d-none d-md-block d-lg-none"
                />
                <GatsbyImage
                  image={ad.mobileImage.localFile.childImageSharp.gatsbyImageData}
                  alt={ad.mobileImage.altText}
                  className="d-md-none"
                />
              </WPLink>
            </div>
          )
        })}
      </Slider>
    </SlideWrap>
  )
}

export default FooterBellyband